module.exports = __webpack_public_path__ + "static/media/Group 1.dff0c622.svg";